import { render, staticRenderFns } from "./room-type.vue?vue&type=template&id=1f2f3fbe&"
import script from "./room-type.vue?vue&type=script&lang=js&"
export * from "./room-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports